define('views/modules/calendar/activity/member/detail/blocks/about-activity',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/info-section',
    // events
    'services/events/calendar-events',
    // templates
    'text!templates/modules/calendar/activity/member/detail/blocks/about-activity.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VInfoSection,
    // events
    CalendarEvents,
    // templates
    TAboutActivity
) {

    var VAboutActivity = Backbone.View.extend({
        template: TAboutActivity,

        regions: {
            date: ".date-input"
        },

        events: {
            'click .activity-description-text a': "onLinkClick"
        },

        initialize: function(opt) {

            var activities = this.activities = opt.activities,
                view = this.view = {
                    info: new VInfoSection({
                        title: "calendar:About this activity",
                        content: this.template,
                        model: this.model,
                        buttonBottom: {
                            text: "Edit",
                            context: this,
                            callback: this.onEditActivity
                        },
                    }),
                };

            this.listenTo(activities, { 'sync': this.onActivitiesSync });
        },

        render: function() {
            var view = this.view,
                model = this.model;

            this.$el.empty();

            if (this.isDisplayed()) {
                this.assign(view.info, this.$el); // must be first
            }

            view.info.applyBindings();

            // Caching scoped jquery element from 'regions'.
            this.generateZones();
            var zone = this.zone;

            return this;
        },

        isDisplayed: function() {
            var model = this.model,
                activity = this.activities.get(model.getActivity());

            if (!activity && model.getName()) {
                return true;
            } else {
                return activity && activity.getName() !== this.model.getName() || model.getDescription();
            }
        },

        onActivitiesSync: function(collection) {
            this.toggle();
        },

        toggle: function() {
            this.$el.toggleClass('hide', Boolean(!this.isDisplayed()));
        },

        onEditActivity: function (e) {
            e.preventDefault();
            this.trigger('edit:activity');
        },

        onLinkClick: function(e) {
            // Open in in-app browser on native platforms
            if (window.Capacitor && window.Capacitor.Plugins.Browser && window.Capacitor.isNativePlatform()) {
                e.preventDefault();
                var Browser = window.Capacitor.Plugins.Browser;
                Browser.open({ url: e.target.href }).catch(function(error) {
                    console.error('Failed to open browser:', error);
                });
            }
        }

    });

    return VAboutActivity;

});

